import { Component, input } from '@angular/core';
import { CarrierNewsItemDto } from '../../../../models/carrier-news-item-dto';
import { DataFieldComponent } from '@myarvato/shared/data-field';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'transport-news-modal',
  imports: [DataFieldComponent, DayjsPipe, TranslatePipe],
  templateUrl: './news-modal.component.html',
  styleUrl: './news-modal.component.scss',
})
export class NewsModalComponent {
  // Inputs
  public readonly newsItem = input.required<CarrierNewsItemDto>();
}
